/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { createContext, useContext, type ReactNode } from 'react';

interface SessionContextValue {
    accessToken: string;
    isSessionExpired: boolean;
    onSessionExpired: () => void;
    username: string;
}

const SessionContext = createContext<SessionContextValue | null>(null);

interface SessionProviderProps {
    accessToken: string;
    children: ReactNode;
    isSessionExpired: boolean;
    onSessionExpired: () => void;
    username: string;
}

function SessionProvider({ accessToken, children, isSessionExpired, onSessionExpired, username }: SessionProviderProps) {
    return (
        <SessionContext.Provider value={{ accessToken, isSessionExpired, onSessionExpired, username }}>
            {children}
        </SessionContext.Provider>
    );
}

function useSession(): SessionContextValue {
    const context = useContext(SessionContext);

    if (!context) {
        throw new Error('useSession must be used within a SessionProvider.');
    }

    return context;
}

export { SessionProvider, useSession };
